<template>
  <v-autocomplete
    v-model="selected"
    :items="options"
    :loading="loading"
    :disabled="loading"
    item-text="nome"
    item-value="municipioPropostaParcelaStatusid"
    label="Status"
    placeholder="Status"
    multiple
    clearable
    @change="emitChange"
  >
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>Nenhum status encontrado</v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import { municipioPropostaParcelasStatus } from "@/apis/proposta";

export default {
  name: "ComboboxParcelasStatus",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      options: [],
      selected: this.value || [],
      loading: false,
    };
  },
  watch: {
    value(val) {
      this.selected = val || [];
    },
  },
  methods: {
    emitChange() {
      this.$emit("change", this.selected);
    },
    loadOptions() {
      this.loading = true;
      municipioPropostaParcelasStatus
        .list()
        .then(({ data }) => {
          this.options = data || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.loadOptions();
  },
};
</script>
